"use client";
import { ElProps, MODE } from "@/type"
import Link from 'next/link'
import { cn, dayjs } from "utils"
import { FC } from "react"
import { ContactUs } from "../ContactUs"

interface PageFooterProps extends ElProps { }
export const PageFooter: FC<PageFooterProps> = ({ className }) => {
  return (
    <div className={cn(
      "flex flex-col box-border justify-between px-[29.5px] py-10 bg-Backgroun-Inverse-Primary-BG",
      "sm:flex-row",
      "md:mb-0 md:px-20 md:py-20",
      "lg:py-30",
      className
    )}>
      <Link href="/" className={cn(
        "w-[186px]",
        "md:w-70",
      )}>
        <img
          src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/bread-butter-logo-dark.svg`}
          alt="bread-butter"
        />
      </Link>
      <div className={cn("flex gap-[15px] sm:gap-10 sm:mt-0 mt-6 items-center")}>
        <span className={cn("text-sm text-Content-Inverse-Primary")}>© {dayjs().year()} BREADnBUTTER</span>
        <ContactUs svgMode={MODE.DARK}/>
      </div>
    </div>
  )
}